import { LoanStatusExternal, MetricMerchantView } from '@nemuru-eng/js-api-client';

import { MerchantScoreCardMetrics } from '@/components/modules/Metrics/shared/components/TopMerchants/types/MerchantScoreCardMetrics';
import { CustomDate } from '@/components/modules/Metrics/shared/entities/CustomDate';
import { MetricAnalyzer } from '@/components/modules/Metrics/shared/entities/MetricAnalyzer';
import { TimeInterval } from '@/components/modules/Metrics/shared/entities/TimeInterval';

export class MerchantMetricAnalyzer {
  constructor(public readonly timeInterval: TimeInterval, public readonly metricViews?: MetricMerchantView[]) {}

  public scoreCardMetrics(loanStatusExternal: LoanStatusExternal): MerchantScoreCardMetrics[] {
    if (!this.metricViews) return [];

    const currentIntervalEndDate = new CustomDate().date;
    const currentIntervalStartDate = new CustomDate().subtractDays(this.timeInterval.days).date;
    const previousIntervalStartDate = new CustomDate().subtractDays(this.timeInterval.days * 2).date;

    const filteredMetricViews = this.metricViews.map((metricView) => {
      return {
        ...metricView,
        metrics: metricView.metrics.filter((metric) => metric.loanStatusExternal === loanStatusExternal),
      };
    });

    const scoreCardMetrics: MerchantScoreCardMetrics[] = [];

    filteredMetricViews.forEach((metricView) => {
      const metricsAccumulatedValues = new MetricAnalyzer(metricView).metricAnalyzerBaseMetrics(
        currentIntervalEndDate,
        currentIntervalStartDate,
        previousIntervalStartDate,
      );

      scoreCardMetrics.push({
        merchantId: metricView.merchantId,
        businessName: metricView.businessName,
        ...metricsAccumulatedValues,
      });
    });

    return scoreCardMetrics
      .sort((a, b) => (b.totalPrincipalAmount.current > a.totalPrincipalAmount.current ? 1 : -1))
      .slice(0, 5);
  }
}
